import { makeStyles } from 'tss-react/mui';
import { PlatformLinkingConnectionStatus } from '@okletsplay/core';

export const useStyles = makeStyles<{ status?: PlatformLinkingConnectionStatus }>()(
  (theme, { status }) => ({
    root: {
      boxShadow: `rgb(0 0 0 / 25%) ${theme.spacing(0)} ${theme.spacing(0.35)} ${theme.spacing(
        0.35
      )}`,
      height: theme.spacing(7.5),
      backgroundColor: theme.palette.background.paper,
      flex: '0 0 auto',
      width: '100%',
      cursor: status === PlatformLinkingConnectionStatus.NotConnected ? 'pointer' : 'default',
      userSelect: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(0.625, 1.875),
      border: `${theme.spacing(0.25)} solid ${theme.palette.background.paper}`,

      '&:hover': {
        border: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`,
      },
    },

    disabled: {
      pointerEvents: 'none',
      opacity: 0.6,
    },

    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },

    platformId: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },

    icon: {
      minWidth: theme.spacing(4),
      width: theme.spacing(4),
      height: theme.spacing(4),
      minHeight: theme.spacing(4),
      marginRight: theme.spacing(1.75),

      '& img': {
        objectFit: 'contain',
        height: '100%',
        width: '100%',
      },
    },

    controls: {
      display: 'flex',
      flexDirection: 'row',
    },

    unlink: {
      lineHeight: 1.5,
      cursor: 'pointer',
      alignSelf: 'center',
      marginLeft: theme.spacing(1),

      '&.MuiTypography-root': {
        fontSize: theme.spacing(1.5),
        textDecoration: 'underline',
        textTransform: 'capitalize',
      },
    },
  })
);
